import { inject, computed } from "vue";
import { PC_RES_SYMBOL, VUE_I18N_SYMBOL } from "_Main/injectionSymbols";

function getResource(globalVueI18n, { namespace, key, count, values }) {
    const finalKey = namespace ? `${namespace}.${key}` : key;

    count = count != null ? normalizeCount(count) : null; // 0 is a valid count
    values = values || null;
    if (typeof count === "number") {
        return globalVueI18n.tc(finalKey, count, values);
    }

    return globalVueI18n.t(finalKey, values);
}

// Count param of $tc expects an integer count value.
function normalizeCount(count) {
    const countNum = Number(count);
    if (isNaN(countNum)) {
        // Use 0 as default because in this case, some
        // 'count' parameter was specified so the caller
        // is expecting us to call $tc with a valid value,
        // even for invalid input
        return 0;
    } else {
        return Math.trunc(countNum);
    }
}

export function mapI18n(keyOptions, namespace) {
    const res = {};
    for (const prop in keyOptions) {
        if (keyOptions.hasOwnProperty(prop)) {
            const value = keyOptions[prop];
            if (typeof value === "string") {
                res[prop] = function () {
                    return this.res({ namespace, key: value });
                };
            } else if (typeof value === "function") {
                res[prop] = function () {
                    const args = value.apply(this);
                    return this.res({ namespace, ...args });
                };
            }
        }
    }
    return res;
}

export function useResource(keyOptions, namespace) {
    const $res = inject(PC_RES_SYMBOL);
    const res = {};
    for (const prop in keyOptions) {
        if (keyOptions.hasOwnProperty(prop)) {
            const value = keyOptions[prop];
            if (typeof value === "string") {
                res[prop] = computed(() => {
                    return $res({ namespace, key: value });
                });
            } else if (typeof value === "function") {
                res[prop] = computed(() => {
                    const args = value.apply(null);
                    return $res({ namespace, ...args });
                });
            }
        }
    }
    return res;
}

function install(vueRootApp) {
    function getGlobalVueI18n() {
        return vueRootApp.runWithContext(() => {
            return inject(VUE_I18N_SYMBOL);
        });
    }
    function res(options) {
        const globalVueI18n = getGlobalVueI18n();
        return getResource(globalVueI18n.global, options);
    }
    vueRootApp.provide(PC_RES_SYMBOL, res);
    vueRootApp.config.globalProperties.res = res;
}

export default {
    install
};
